import { List, ListItem } from '@shared/components';

const FALLBACK_LEVEL_NAME = 'ไม่ระบุ';

interface DisabledLOSListProps {
  losList: { id: string; name: string | null }[];
}

export default function DisabledLOSList(props: Readonly<DisabledLOSListProps>) {
  const { losList } = props;

  return (
    <List
      sx={(theme) => ({
        listStyle: 'disc',
        display: 'flex',
        flexDirection: 'column',
        p: theme.spacing(0, 0, 0, 6),
      })}
    >
      {losList.map((los) => (
        <ListItem
          key={los.id}
          sx={(theme) => ({
            display: 'list-item',
            p: theme.spacing(0),
            ...theme.typography.body2,
          })}
        >
          {los.name ?? FALLBACK_LEVEL_NAME}
        </ListItem>
      ))}
    </List>
  );
}
